<template>
  <div>
    <div class="mb-4 flex justify-between items-center">
      <ExportMenu
        :disabled="!rowData.length"
        :exports="[{ type: 'excel', action: exportToExcel }]"
      />
    </div>

    <div style="height: 500px;">
      <AgGridVue
        :theme="compactListTheme"
        style="width: 100%; height:100%"
        :column-defs="columnDefs"
        :row-data="rowData"
        :default-col-def="defaultColDef"
        :grid-options="gridOptions"
        :loading="loading"
        @grid-ready="onGridReady"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import axios from 'axios';
import { AgGridVue } from 'ag-grid-vue3';
import {compactListTheme} from '@/utils/common';
import ExportMenu from '@/components/widgetcomponents/library/ExportMenu.vue';

export default defineComponent({
  name: 'Details_Patient_EHR_Claims',
  computed: {
    compactListTheme() {
      return compactListTheme
    },
  },
  components: {
    AgGridVue,
    ExportMenu,
  },
  props: {
    patientIdentifier: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      rowData: [],
      gridApi: null,
      gridOptions: {
        suppressAggFuncInHeader: true,
        domLayout: this.autoHeight ? 'autoHeight' : null,
        animateRows: true,
      },
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
      },
      columnDefs: [
        {
          field: 'bene_mbi_id',
          headerName: 'Beneficiary MBI ID',
          cellClass: 'sensitive',
        },
        {
          field: 'service_date',
          headerName: 'Service Date',
          sort: 'desc',
          valueFormatter: this.dateFormatter,
        },
        {
          field: 'cpt_code',
          headerName: 'CPT Code',
        },
        {
          field: 'npi',
          headerName: 'Provider NPI',
          cellClass: 'sensitive',
        },
        {
          field: 'tin',
          headerName: 'TIN',
          cellClass: 'sensitive',
        },
        {
          field: 'ccn',
          headerName: 'CCN',
        },
        {
          field: 'source',
          headerName: 'Source',
        },
      ]
    };
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const response = await axios.post('api/returnpatientdata/', {
          data_type: 'ehr_claims',
          patient_identifier: this.patientIdentifier,
        });

        this.rowData = response.data || [];
      } catch (error) {
        console.error('Error fetching EHR claims data:', error);
        this.rowData = [];
      } finally {
        this.loading = false;
      }
    },
    onGridReady(params) {
      this.gridApi = params.api;
      params.api.sizeColumnsToFit();
      window.addEventListener('resize', this.onWindowResize);
    },
    exportToExcel() {
      if (this.gridApi) {
        this.gridApi.exportDataAsExcel({
          fileName: `patient_ehr_claims_${this.patientIdentifier}_${new Date().toISOString().split('T')[0]}.xlsx`,
          sheetName: 'EHR Claims'
        });
      }
    },
    onWindowResize() {
      if (this.gridApi) {
        this.gridApi.sizeColumnsToFit();
      }
    },
    dateFormatter(params) {
      if (!params.value) return '';
      const date = new Date(params.value + 'T00:00:00');
      if (isNaN(date)) return params.value;
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    }
  },
  mounted() {
    this.fetchData();
  }
});
</script>

<style scoped>
</style>
